import React from 'react';
import { aboutContent } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="sobre-mi" className="section-padding bg-[#f0f0f0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={aboutContent.image}
                alt="Luciana Belén - Make Up Artist & Hair"
                className="w-full h-full object-cover object-top img-hover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -top-6 -right-6 w-40 h-40 border border-[#bcbbb4] -z-10" />
          </div>

          {/* Content */}
          <div>
            <p className="hero-subtitle text-[#666] mb-4">
              Conóceme
            </p>
            <h2 className="section-title text-[#333] mb-8">
              {aboutContent.title}
            </h2>
            <div className="space-y-6">
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="body-large text-[#666]">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Signature - Same as main logo */}
            <div className="mt-10 pt-8 border-t border-[#bcbbb4]/50">
              <p className="font-display text-xl font-light tracking-[0.15em] text-[#333]">
                LUCIANA BELÉN
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
